module.exports = global["$"] = require("-!/mapcontrib/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/jquery/dist/jquery.js-exposed
// module id = 5
// module chunks = 3